import _ from 'underscore';
import { useMemo, useContext } from 'react';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';

const DEFAULT_OPTIONS = {};

export const useCustomerLevelVariables = () => {
  const serverContext = useContext(ServerContext);
  const { CurrentUser, CurrentCustomer } = serverContext || {};
  const { Id: customerId } = CurrentCustomer || {};
  const { Id: userId } = CurrentUser || {};

  return useMemo(() => ({
    locator: {
      descriptor: {
        uid: userId,
        cid: customerId,
        customer_id: customerId,
      },
    },
  }), [userId, customerId]);
};

export const useAccountLevelVariables = (options = DEFAULT_OPTIONS) => {
  const serverContext = useContext(ServerContext);
  const { CurrentUser, CurrentAccount, CurrentCustomer } = serverContext || {};
  const { Id: customerId } = CurrentCustomer || {};
  const { Id: accountId } = CurrentAccount || {};
  const { Id: userId } = CurrentUser || {};

  return useMemo(() => (_.extend({}, options, {
    locator: {
      descriptor: {
        uid: userId,
        cid: customerId,
        aid: accountId,
        customer_id: customerId,
        account_id: accountId,
      },
    },
  })), [options, userId, customerId, accountId]);
};

export const useAccountLevelVariablesWithAdvertiserCustomerId = (options = DEFAULT_OPTIONS) => {
  const serverContext = useContext(ServerContext);
  const { CurrentUser, CurrentAccount, CurrentCustomer } = serverContext || {};
  const { Id: currentCustomerId } = CurrentCustomer || {};
  const { Id: aid } = CurrentAccount || {};
  const { Id: uid } = CurrentUser || {};

  // get the customer id from the CurrentAccount instance
  const cid = _.get(CurrentAccount, 'AdvertiserCustomerID', currentCustomerId);

  return useMemo(() => ({
    ...options,
    locator: {
      descriptor: {
        uid,
        cid,
        aid,
        customer_id: cid,
        account_id: aid,
      },
    },
  }), [options, uid, cid, aid]);
};

export const usePostponeReadVariables = lookupCacheByVariables => useMemo(
  () => (
    lookupCacheByVariables ?
      {
        fetch: {
          postponeRead: true,
          lookupCacheByVariables,
        },
        refetch: {
          lookupCacheByVariables,
        },
        mutation: {
          lookupCacheByVariables,
        },
      } :
      {
        fetch: {
          postponeRead: true,
        },
      }),
  [lookupCacheByVariables]
);
